// src/components/kiosk/TimestampDisplay.jsx
import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const TimestampDisplay = ({ 
  timestamp,
  action = 'Einstempeln',
  className = ''
}) => {
  const normalize = (value) => value?.toLowerCase()?.replace(/-/g, ' ')?.trim();
  const toGermanAction = (value) => {
    const n = normalize(value);
    if (n === 'clock in') return 'Einstempeln';
    if (n === 'clock out') return 'Ausstempeln';
    if (n === 'break start') return 'Pausenbeginn';
    if (n === 'break end') return 'Pausenende';
    return value || '';
  };
  const displayAction = toGermanAction(action);
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (date) => {
    return date?.toLocaleTimeString('de-DE', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
  };

  const formatDate = (date) => {
    return date?.toLocaleDateString('de-DE', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const displayTime = timestamp ? new Date(timestamp) : currentTime;

  return (
    <div className={`bg-card border border-border rounded-lg p-6 ${className}`}>
      <div className="text-center space-y-4">
        {/* Action Header */}
        <div className="flex items-center justify-center space-x-2">
          <Icon 
            name="Clock" 
            size={24} 
            className="text-primary"
          />
          <h4 className="text-xl font-medium text-text-primary">
            {displayAction} Zeit
          </h4>
        </div>

        {/* Time Display */}
        <div className="space-y-2">
          <div className="text-4xl font-bold text-primary font-mono">
            {formatTime(displayTime)}
          </div>
          <div className="text-lg text-text-secondary">
            {formatDate(displayTime)}
          </div>
        </div>

        {/* Server Sync Indicator */}
        <div className="flex items-center justify-center space-x-2 text-sm text-text-secondary">
          <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
          <span>Server synchronisiert</span>
        </div>
      </div>
    </div>
  );
};

export default TimestampDisplay;